import axios from "axios";
import { baseUrl, auth } from "./utils";
import {showError} from "./error";

export const SET_TENANT_PROPERTY = "SET_TENANT_PROPERTY";
export const CLEAR_TENANT_DATA = "CLEAR_TENANT_DATA";

export function setTenantProperty( property ) {
    return {
        type: SET_TENANT_PROPERTY,
        property: property
    }
}

export function clearTenantData() {
    return {
        type: CLEAR_TENANT_DATA
    }
}

export function loadTenantProperty() { return ( dispatch, getState ) => {
    const user = getState().user.data;
    axios.get( `${baseUrl}/properties/user/${user.id}`, auth( getState ) )
    .then( response => {
        console.log( `GET /properties/user/${user.id} response:`, response.data );
        const property = response.data[0] || {};
        dispatch( setTenantProperty( property ) );
    } )
    .catch( error => {
        dispatch(showError(error.response.data.message))
        console.log( `GET /properties/user/${user.id} error:`, error );
    } )
} }